<template >
    <div v-if="activityInfo" style="padding: 24px">
         <div class="top-bar com-model m-b-24" style="padding: 11px 24px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/index/jobfair' }">招聘会</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/index/jobfair/info', query: { jbid: activityInfo.id} }">招聘会详情</el-breadcrumb-item>
                <el-breadcrumb-item>企业报名表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="com-model" style="padding: 0 25px 38px">
            <div class="title m-b-24">企业报名表</div>
            <div class="flex flex-wrap m-b-16">
                <div class="flex company-item">
                    <div class="hadbm-list-name">企业名称： </div>
                    <div class="hadbm-list-namein">{{$store.state.hrinfo.companyName}}</div>
                </div>
                <div class="flex company-item">
                    <div class="hadbm-list-name">联系人： </div>
                    <div class="hadbm-list-namein">{{activityInfo.name}}</div>
                </div>
                <div class="flex company-item">
                    <div class="hadbm-list-name">联系方式： </div>
                    <div class="hadbm-list-namein">{{activityInfo.phone}}</div>
                </div>
                <div class="flex company-item">
                    <div class="hadbm-list-name">举办地址： </div>
                    <div class="hadbm-list-namein">{{activityInfo.address}}</div>
                </div>
            </div>
            <div class=""  v-if="!!activityInfo.seatImage">
                <div class="in-title">场地平面图</div>
                <div class="seat-image">
                    <img :src="activityInfo.seatImage" alt="">
                </div>
            </div>
            <div class="tanwei m-b-14" v-if="seatInfo.length > 0">
                <div class="tanwei-tit m-b-16">
                    <span>选择摊位</span><span  v-if="seatno">,  您已选择<span style="color:rgba(5, 124, 249, 1)">{{seatno}}</span>摊位</span>
                </div>
                <div class="tanwei-list flex flex-wrap">
                    <div class="tanwei-item" v-for="(item,index) in seatInfo" :class="{'active':item.id == seatid}" :key="index" @click="searSel(item.id,item.no)">{{item.no}}</div>
                </div>
            </div>
            <div class="tanwei m-b-14" v-if="!seatInfo.length && tempseatInfo.length">
                <div class="tanwei-tit tanwei-temptit m-b-16">
                    <span class="tanwei-temptit-sd">临时摊位</span><span  v-if="seatno">,  您已选择<span style="color:rgba(5, 124, 249, 1)">{{seatno}}</span>摊位</span>
                </div>
                <div class="tanwei-list tanwei-templist flex flex-wrap">
                    <div v-for="(item,index) in tempseatInfo" :class="{'active':item.id == seatid}" :key="index" @click="searSel(item.id,item.no)">{{item.no}}</div>{{seatno}}摊位</span>
                </div>
                <div class="tanwei-list tanwei-templist flex flex-wrap">
                    <div  class="tanwei-item" v-for="(item,index) in tempseatInfo" :class="{'active':item.id == seatid}" :key="index" @click="searSel(item.id,item.no)">{{item.no}}</div>
                </div>
            </div>
            <div class="primary-btn" style="width: 160px" @click="subJobfair">提交报名信息</div>
        </div>
    </div>
</template>
<script>
import { activeSuccess } from '@/assets/js/msgbox'
export default {
    name: 'jobfair-seat',
    data () {
        return {
            activityInfo: null,
            tempseatInfo: [],
            seatInfo: [],
            seatid: null,
            seatno: null
        }
    },
    created() {
        this.jbid = this.$route.query.jbid;
        this.getInfo();
        this.getSeatInfo();
        this.getTempSeatInfo();
    },
    methods: {
        getInfo() {
            this.axios.get("/wapi/activity/get?activityId=" + this.jbid).then(res => {
                if (res.success) {
                this.activityInfo = res.data;
                var img = new Image();
                img.src = res.data.seatImage + "?t=" + Math.random();
                let w, h;
                let self = this;
                img.onload = function() {
                    w = img.width;
                    h = img.height;
                    self.list.push({
                    src: res.data.seatImage,
                    w,
                    h
                    });
                };
                }
            });
        },
        getTempSeatInfo() {
           this.axios
                .get("/wapi/activity/listUnselectTempSeat?activityId=" + this.jbid)
                .then(res => {
                if (res) {
                    this.tempseatInfo = res;
                }
                })
                .catch(res => {});
        },
        getSeatInfo() {
            this.axios
                .get("/wapi/activity/listUnselectSeat?activityId=" + this.jbid)
                .then(res => {
                if (res) {
                    this.seatInfo = res;
                }
                })
                .catch(res => {});
        },
        searSel(id, no) {
            this.seatid = id;
            this.seatno = no;
        },
        subJobfair () {
            this.axios
            .get(
            `/wapi/activity/sign?activityId=${this.jbid}&seatId=${this.seatid}`
            )
            .then(res => {
                if (res.success) {
                   activeSuccess({
                        companyName: this.activityInfo.companyName
                    }, this)
                    this.$router.back();
                }
            });
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../../assets/less/base.less');
.title{
  font-size: 24px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 74px;
  border-bottom: 1px solid #D2D2D2;
  span{
    color: rgba(153, 153, 153, 1);
  }
}
.company-item{
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    margin-right: 120px;
    margin-bottom: 14px;
}
.in-title{
    height: 28px;
    font-size: 20px;
    font-weight: 500;
    color: #222222;
    line-height: 28px;
    margin-bottom: 12px;
}
.seat-image{
    height: 220px;
    text-align: center;
    img{
        max-width: 100%;
        max-height: 100%;
    }
}
.tanwei-tit{
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC, 'Microsoft Yahei', '微软雅黑', Sans-serif;
    font-weight: 500;
    color: #222222;
    line-height: 28px;
}
.tanwei-item{
    width: 86px;
    height: 36px;
    border-radius: 2px;
    border: 1px solid #E6E6E6;
    line-height: 36px;
    text-align: center;
    margin-right: 16px;
    margin-bottom: 16px;
    font-size: 16px;
    cursor: pointer;
    color: rgba(73, 73, 73, 1);
    &.active{
        border: 1px solid #057CF9;
    }
}
.primary-btn{
    line-height: 40px;
    height: 40px;
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// Jobfairseat.vue?0fa71f96